/* @flow */

import React from 'react';

import Box from '@material-ui/core/Box';

import PageSubTitleViewComponent from 'components/pageTitle/subTitle';
import TwoFactorSetupComponent from 'app/users/twoFactorSetup';

type SubscriptionTab2FAComponentProps = {
  successHandler: () => void;
}

export default function SubscriptionTab2FAComponent(props: SubscriptionTab2FAComponentProps) {
  return (
    <Box p={3}>
      <PageSubTitleViewComponent id="twofactor.header" />
      <TwoFactorSetupComponent
        onComplete={props.successHandler}
        onCancel={props.successHandler}
        cancelLabelId="twofactor.setuplater"
      />
    </Box>
  );
}
